const getLocalStorage = (): boolean => {
    try {
        return !!window.localStorage
    } catch (e) {
        return true
    }
}

export default getLocalStorage;